export default __webpack_public_path__ + "static/media/hero.056d0f6e.png";